$ = require 'jquery'
Auth = require 'db/auth'
BoardListSectionHeaderComponent = require 'views/board-list/board-list-section-header-component'
BoardListSectionHeaderLinkComponent = require 'views/board-list/board-list-section-header-link-component'
BoardsPageUpNextInfoView = require 'views/member/boards-page-up-next-info-view'
BoardsPageUpNextCardComponent = require 'views/member/boards-page-up-next-card-component'
_ = require 'underscore'
f = require 'effing'
l = require 'lib/localize'
PopOver = require 'views/lib/pop-over'
React = require 'react'
startDecayingInterval = require 'lib/util/decaying-interval'
t = require('views/internal/recup-with-helpers')('boards_page_up_next')
track = require 'debug/track'
Util = require 'lib/util'
Dates = require 'lib/dates'
ApiPromise = require 'network/api-promise'

class BoardsPageUpNextComponent extends React.Component
  displayName: 'BoardsPageUpNextComponent'

  constructor: (props) ->
    @state =
      upNextCards: []
      optimisticallyDismissedCardIds: {}
      shouldShowPopOver: !Auth.me().isDismissed('upNextExperimentInfoPopover')

    @dismissTimeout = null
    @nextPollCallbacks = []
    @trackOnClickInfoButton = @trackOnClickInfoButton.bind(@)
    @showInitialPopOver = @showInitialPopOver.bind(@)
    @showInfoPopOver = @showInfoPopOver.bind(@)
    @dismissCard = @dismissCard.bind(@)
    @updateUpNextCards = @updateUpNextCards.bind(@)

  componentDidMount: ->
    @updateUpNextCards(@showInitialPopOver)
    @startPollingForUpNextCards()

  componentWillUnmount: ->
    @cancelDecayingInterval()

    if (@dismissTimeout)
      clearTimeout(@dismissTimeout)

  updateUpNextCards: (callback) ->
    { getUpNextCards } = @props

    getUpNextCards().then (upNextCards) =>
      @setState upNextCards: upNextCards, callback

  startPollingForUpNextCards: ->
    @cancelDecayingInterval = startDecayingInterval =>
      @updateUpNextCards(@nextPollCallback())

  onNextPoll: (callback) ->
    @nextPollCallbacks.push callback

  nextPollCallback: ->
    if @nextPollCallbacks.length == 0
      return _.noop

    callbacks = @nextPollCallbacks.slice()
    @nextPollCallbacks = []
    -> callbacks.map (callback) -> callback()

  showInitialPopOver: ->
    if @state.shouldShowPopOver && @state.upNextCards.length
      @showInfoPopOver()

      @setState
        shouldShowPopOver: false

      Auth.me().dismiss('upNextExperimentInfoPopover')

  showInfoPopOver: ->
    PopOver.toggle
      elem: $('.js-up-next-info')
      view: new BoardsPageUpNextInfoView({ memberId: Auth.me().get('id') })

  trackOnClickInfoButton: (e) ->
    Util.preventDefault(e)
    @showInfoPopOver()
    track('Boards View', 'Up Next', 'Clicked info button')
    return

  dismissCard: (cardId) ->
    # optimistically dismiss card with a slight delay
    @dismissTimeout = setTimeout (=>
      @setState (prevState, props) ->
        optimisticallyDismissedCardIds:
          _.extend {}, prevState.optimisticallyDismissedCardIds, { "#{cardId}": true }
    ), 250

    ApiPromise
      url: "1/members/me/upNext/#{cardId}"
      type: 'post'
    .then =>
      # Dismissed cards won't be included in the next poll, which means they
      # no longer need to be optimistically hidden.
      @onNextPoll => @setState (prevState, props) ->
        optimisticallyDismissedCardIds:
          _.omit prevState.optimisticallyDismissedCardIds, cardId
    .done()

  render: t.renderable ->
    { upNextCards, optimisticallyDismissedCardIds } = @state

    upNextCards = upNextCards.filter (upNext) -> !optimisticallyDismissedCardIds[upNext.card.id]

    if upNextCards.length
      t.div '.up-next-cards.boards-page-board-section.mod-no-sidebar',
        ref: (el) -> Dates.update(el)
      , =>
        t.addElement React.createElement BoardListSectionHeaderComponent, {
          title: l('board section title.up next')
          iconClass: 'notification'
          linkElements: [
            {
              url: '#',
              iconClass: 'information',
              linkClasses:
                'js-up-next-info': true,
                'up-next-info': true
              titleKey: 'info',
              onClick: @trackOnClickInfoButton
            }
          ].map(f.choke(1, React, 'createElement', BoardListSectionHeaderLinkComponent))
        }

        t.ul '.boards-page-board-section-list', =>
          upNextCards.map (upNext, index) =>
            if index < 4
              t.addElement React.createElement BoardsPageUpNextCardComponent, {
                dueSoon: upNext.dueSoon
                card: upNext.card
                mentions: upNext.mentions
                modelCache: @props.modelCache
                dismissCard: @dismissCard
              }

    else
      t.div()

module.exports = {
  BoardsPageUpNextComponent
}



// WEBPACK FOOTER //
// ./app/scripts/views/member/boards-page-up-next-component.coffee